import { ValidTimeZone } from '@iotv/iotv-v3-types'
import { supportedTZs } from '../../selectedConfig'
import { UserAttributeDefs } from '../../types/ModelTypes'
import { GeoModelCommon } from './GeoModelCommon'

const typeName = 'Region'

export type RegionProps = {
  name?: string
  type: string
  tz?: ValidTimeZone
}

class Region extends GeoModelCommon {
  constructor(ob: Partial<RegionProps>) {
    super({ ...ob, type: ob.type || typeName })
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'identification' },
      description: { type: 'String', editable: true, label: 'Description', description: 'description' },
      tz: {
        type: 'Enum',
        editable: true,
        enumKv: Object.fromEntries(supportedTZs.map((tz) => [tz, tz])),
      },
    }
  }
}

export { Region }
